import React from "react";
export const Padlock = ({ className }: { className?: string }) => (
  <svg
    className={`h-4 w-4 mr-1 ${className || "text-gray-100"}`}
    fill="currentColor"
    viewBox="0 1 20 20"
  >
    <path
      fillRule="evenodd"
      d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
      clipRule="evenodd"
    ></path>
  </svg>
);
